import MainModuleRugsRow from './MainModuleRugsRow'
export default MainModuleRugsRow
